export default __webpack_public_path__ + "static/media/penguin.cceef6e9.png";